import { useStaticQuery, graphql, Link } from "gatsby";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import ContentContainer from "../container/ContentContainer";
import PreviewItem from "./PreviewItem";

const ProductFeatureUpdateArauco = ({ className, titleClassName, contentClassName }) => {
  const images = useStaticQuery(graphql`
    {
      emporioSkin: file(relativePath: { eq: "emporio-skin-section.png" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
      oneskin: file(relativePath: { eq: "oneskin-related-section.png" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
      arauco: file(relativePath: { eq: "Arauco-featured-section.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
      statePlus: file(relativePath: { eq: "ridgemont-collection-featured-section.png" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
      lunaWood: file(relativePath: { eq: "lunawood-featured-section.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP]
            quality: 100
          )
        }
      }
    }
  `);
  const contentData = [
    {
      title: "Ridgemont Pre-Finished Wood Panels from States+",
      content:
        "States Industries introduces their Ridgemont Collection of Brushed Veneer Pre-Finished Wood Panels for interior applications. This collection draws inspiration from the beauty found in nature.",
      content2: "The detailed wire brushing process brings out the best of the wood grain, highlighting the rich depth and natural elegance to showcase your cabinet and furniture designs.",
      link: "Learn More",
      url: "/products/pre-finished-wood-panels",
      image: images.statePlus,
    },
    {
      title: "Thermofused Laminates from Emporio Skin",
      content:
        "Emporio Skin: A new line of Premium European Thermo Fused Laminates. The charm of the material and endless combinations that will define your space.",
      content2:
        "Skin was born in 2010 for the most demanding customers. From Italy to Europe and the world conquers growing market shares with its collections of ennobled by the exclusive visual and tactile characteristics.",
      link: "Learn More",
      url: "/products/thermofused-laminates",
      image: images.emporioSkin,
    },
    {
      title: "Lacquered Boards from OneSkin",
      content:
        "OneSkin has been created to supply worldwide markets with high quality lacquered boards that open new possibilities in the furniture industry, interior decorations, paneling, and other architectural purposes.",
      link: "Learn More",
      url: "/products/lacquered-boards",
      image: images.oneskin,
    }    
  ];

  const lunaWoodImage = getImage(images.lunaWood);
  const AraucoImage = getImage(images.arauco);

  return (
    <ContentContainer
      className="flex flex-col w-full lg:w-1000px mb-20"
      titleText="Featured Products"
      titleClassName="px-4 lg:px-0 my-20 text-3xl"
    >
      <div className="hidden sm:flex flex-col space-y-5 ">
        <div
          className="flex flex-col items-stretch bg-gray2 lg:flex-row"
        >
          <div
            className="w-full lg:w-6/12 p-10 sm:p-16 flex flex-col justify-center space-y-5 text-left"
          >
            <h2>Featured</h2>
            <h3 className="pb-10 font-bold">Arauco Prism<sup>&reg;</sup> Thermally Fused Laminates</h3>
            <div>
              <p>Arauco Prism<sup>&reg;</sup> features authentic, tactile textures and realistic woodgrains, abstract, and solid designs. Using climate-positive composite wood cores allows our products to contribute to green building certifications like LEED.</p>
              <p className="pt-2">This hard-wearing surface is suitable for vertical and low-impact horizontal applications, replacing wood veneer.</p>
              <p className="pt-2">Such a versatile product, it is ideal for various applications, including cabinets, casework, furniture, and retail interiors.</p>
              <p className="text-sm pt-4"><span className="font-bold uppercase">Photo</span>: Cabinetry by Paragon concepts, Longmont, CO</p>
            </div>
            <Link className="text-left" to="/products/thermally-fused-laminates">Learn More</Link>
          </div>
          <div className="w-full lg:w-55%">
            <GatsbyImage as="div" image={AraucoImage} objectFit="cover" className="w-full h-full" alt="Peview" />
          </div>
        </div>
        <div
          className="flex flex-col items-stretch bg-gray2 lg:flex-row"
        >
          <div className="w-full lg:w-55%">
            <GatsbyImage as="div" image={lunaWoodImage} objectFit="cover" className="w-full h-full" alt="Peview" />
          </div>
          <div
            className="w-full lg:w-6/12 p-10 sm:p-16 flex flex-col justify-center space-y-5 text-left"
          >
            <h2>Featured</h2>
            <h3 className="pb-10 font-bold">Lunawood ThermoWood<sup>&reg;</sup> Thermally Modified Wood Products</h3>
            <div>
              <p>Lunawood’s thermally modified wood products have been crafted with over 20 years of experience. The Lunawood story began in Finland in the 1990’s with the development of an innovative wood processing method using only heat and steam.</p>
              <p className="pt-4">This led to the creation of the patented ThermoWood<sup>&reg;</sup> process on an industrial scale. Still today, their products are enhanced without chemicals, backed by their solid experience.</p>
              <p className="text-sm pt-4"><span className="font-bold uppercase">Photo</span>: Honorary Consulate of Finland in Cape Town</p>
              <p className="text-sm pt-1"><span className="font-bold uppercase">Architect</span>: Adler Price Architects/M.A.R.K.</p>
            </div>
            <Link className="text-left" to="/products/thermally-modified-wood">Learn More</Link>
          </div>
        </div>
        {contentData.map((d, index) => {
          const image = getImage(d.image);
          const imageAlign = index % 2 === 0 ? "right" : "left";
          const contentAlign = index % 2 === 0 ? "left" : "right";
          return (
            <PreviewItem
              className="text-semibold"
              key={`ProductFeatureUpdateArauco${index}`}
              title="FEATURED"
              description={d.title}
              url={d.url}
              linkText={d.link}
              backgoundColor="bg-gray2"
              titleClassName="pb-10 text-bold"
              image={image}
              imageAlign={imageAlign}
              imageFit="cover"
              contentAlign={contentAlign}
            >
              <p className={contentClassName}>{d.content}</p>
              {d.content2 && <p className={`pt-4 ${contentClassName}`}>{d.content2}</p>}
            </PreviewItem>
          );
        })}
      </div>

      <div className="flex sm:hidden flex-col space-y-5 ">
        <div className="w-full text-center py-4"><h2>Featured</h2></div>
        <div
          className="flex flex-col items-stretch bg-gray2"
        >
          <div className="w-full lg:w-55%">
            <GatsbyImage as="div" image={AraucoImage} objectFit="cover" className="w-full h-full" alt="Peview" />
          </div>
          <div
            className="w-full lg:w-6/12 p-10 sm:p-16 flex flex-col justify-center space-y-5 text-left"
          >
            <h3 className="pb-10 font-bold">Arauco Prism<sup>&reg;</sup> Thermally Fused Laminate</h3>
            <div>
              <p>Arauco Prism<sup>&reg;</sup> features authentic, tactile textures and realistic woodgrains, abstract, and solid designs. Using climate-positive composite wood cores allows our products to contribute to green building certifications like LEED.</p>
              <p className="pt-2">This hard-wearing surface is suitable for vertical and low-impact horizontal pplications, replacing wood veneer.</p>
              <p className="pt-2">Such a versatile product, it is ideal for various applications, including cabinets, casework, furniture, and retail interiors.</p>
              <p className="pt-2"><span className="font-bold uppercase">Photo</span>: Cabinetry by Paragon concepts, Longmont, CO</p>
            </div>
            <Link className="text-right" to="/products/thermally-fused-laminate">Learn More</Link>
          </div>
        </div>
        <div className="w-full text-center py-4"><h2>Featured</h2></div>
        <div
          className="flex flex-col items-stretch bg-gray2"
        >
          <div className="w-full lg:w-55%">
            <GatsbyImage as="div" image={lunaWoodImage} objectFit="cover" className="w-full h-full" alt="Peview" />
          </div>
          <div
            className="w-full lg:w-6/12 p-10 sm:p-16 flex flex-col justify-center space-y-5 text-left"
          >
            <h3 className="pb-10 font-bold">Lunawood ThermoWood<sup>&reg;</sup> Thermally Modified Wood Products</h3>
            <div>
              <p>Lunawood’s thermally modified wood products have been crafted with over 20 years of experience. The Lunawood story began in Finland in the 1990’s with the development of an innovative wood processing method using only heat and steam.</p>
              <p className="pt-2">This led to the creation of the patented ThermoWood<sup>&reg;</sup> process on an industrial scale. Still today, their products are enhanced without chemicals, backed by their solid experience.</p>
              <p className="pt-2"><span className="font-bold uppercase">Photo</span>: Honorary Consulate of Finland in Cape Town</p>
              <p className="pt-2"><span className="font-bold uppercase">Architect</span>: Adler Price Architects/M.A.R.K.</p>
            </div>
            <Link className="text-right" to="/products/thermally-modified-wood">Learn More</Link>
          </div>
        </div>
        {contentData.map((d, index) => {
          const image = getImage(d.image);
          return (
            <PreviewItem
              className="text-semibold"
              key={`ProductFeatureUpdateArauco${index}`}
              description={d.title}
              url={d.url}
              linkText={d.link}
              backgoundColor="bg-gray2"
              titleClassName="pb-10 text-bold"
              image={image}
              imageAlign="left"
              imageFit="cover"
              contentAlign="left"
              linkClassName="text-right"
            >
              <p className={contentClassName}>{d.content}</p>
              {d.content2 && <p className={`pt-2 ${contentClassName}`}>{d.content2}</p>}
            </PreviewItem>
          );
        })}
      </div>
    </ContentContainer>
  );
};

export default ProductFeatureUpdateArauco;
